import React from 'react'
import TableHeaderCell from '_core/components/Table/TableHeaderCell'
import clsx from 'clsx'

interface Props {
  onSort?: () => void
  sortingName?: string
  children: React.ReactNode
  isEditMode?: boolean
  hideHeader?: boolean
  isShowStatus?: boolean
}

export const ProductListHeader: React.FC<Props> = ({
  onSort,
  sortingName,
  children,
  isEditMode,
  hideHeader,
  isShowStatus,
}) => {
  if (hideHeader) {
    return null
  }
  return (
    <div className='row mb-5'>
      <div className='table-responsive'>
        <table
          id='OrderList'
          className='table table-row-dashed table-row-gray-300 align-middle gs-0'
        >
          <thead>
            <tr className='fw-bolder text-muted'>
              {sortingName ? (
                <TableHeaderCell sort id={sortingName} onClick={onSort}>
                  Item
                </TableHeaderCell>
              ) : (
                <td className={clsx(isEditMode ? 'min-w-300px' : 'min-w-140px ')}>Item</td>
              )}
              {isShowStatus && <td className='min-w-140px'>Status</td>}
              <td className='min-w-140px'>Price</td>
              <td>QTY</td>
              <td className='text-end'>Total</td>
              {isEditMode && <td className='text-end'></td>}
            </tr>
          </thead>
          <tbody>{children}</tbody>
        </table>
      </div>
    </div>
  )
}

export default ProductListHeader
